"use client";

import type { ReactNode } from "react";
import { PageLoader } from "@/components/page-loader";
import { PwaShell } from "@/components/pwa-shell";
import { Shell } from "@/components/shell";
import { ToastProvider } from "@/components/toast";
import { TopProgress } from "@/components/top-progress";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ToastProvider>
      <PwaShell />
      <TopProgress />
      <PageLoader />
      <Shell>{children}</Shell>
    </ToastProvider>
  );
}
